<app-payment-result [order]="order" (continueShopping)="continueShopping()"></app-payment-result>

